const ReferenceInput = ({ text, handleOpen, disabled, inputSize }) => {
  return (
    <div
      style={{
        height:
          inputSize === "sm"
            ? "calc( 0.45em + 1.25rem + 5px)"
            : "calc( 1.5em + 1.25rem + 5px)",
        borderRadius: "0.25rem",
        fontSize: "0.875rem",
        lineHeight: 1.5,
        padding: inputSize === "sm" ? "0.25rem 0.5rem" : "0.625rem 0.75rem",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        background: disabled ? "#c6cac7" : "unset",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      className="border"
      onClick={disabled ? null : handleOpen}
    >
      {text || "--"}
    </div>
  );
};

export default ReferenceInput;
